import { axiosWithAuth } from "@/lib/AxiosClient";

export interface Tenant {
  id: string;
  name: string;
}

export class TenantService {
  private static readonly BASE_PATH = "/api/tenants"
  private static instance = axiosWithAuth;

  static async getMyTenants(): Promise<Tenant[]> {
    const response = await this.instance.get<Tenant[]>(`${this.BASE_PATH}/me`);
    return response.data;
  }  
}